require('./RAErrorFetchingCountryOfResidenceModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { OKButton } = require('commonsComponents/OKButton');
const { ModalCustom } = require('commonsComponents/modalCustom');

class RAErrorFetchingCountryOfResidenceModal extends React.Component {
    render() {
        if (!__CONTACT_CENTER__) {
            return null;
        }

        return (
            <ModalCustom
                isOpen={this.props.showModal}
                extraClass="error-fetching-country-of-resindence-modal"
                shouldCloseOnOverlayClick={false}
                overlayClassName="error-fetching-country-of-resindence-modal__overlay"
                onRequestClose={this.props.closeModal} // eslint-disable-line
            >
                <div className="error-fetching-country-of-resindence-modal__title">
                    {this.props.title}
                </div>
                <div className="error-fetching-country-of-resindence-modal__description">
                    {this.props.message}
                </div>
                <div className="error-fetching-country-of-resindence-modal__button">
                    <OKButton onClick={this.props.closeModal} // eslint-disable-line
                    >
                        {this.props.button}
                    </OKButton>
                </div>
            </ModalCustom>
        );
    }
}

RAErrorFetchingCountryOfResidenceModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
};

module.exports = RAErrorFetchingCountryOfResidenceModal;
